import {Pipe, PipeTransform} from '@angular/core';
import {ChallengeViewCycle} from 'src/app/core/model/project';
import {normalizeMetricValues} from 'src/app/current-sked/challenge/shared/cycle-metric.util';
import {getColorForName} from 'src/app/shared/utils/name-to-color.util';

export interface CycleDisplayItem {
  metricId: string;
  name: string;
  icon: string;
  color: string;
  score: number;
  dailyScores: number[];
}

@Pipe({
  name: 'cycleDisplayItems',
  standalone: true,
})
export class CycleDisplayItemsPipe implements PipeTransform {
  transform(cycle: ChallengeViewCycle): CycleDisplayItem[] {
    if (!cycle.metrics?.length) return [];
    return cycle.metrics.map(metric => ({
      metricId: metric.metricId,
      name: metric.metricName,
      icon: metric.taskIcon,
      color: getColorForName(metric.metricId, 'metric'),
      score: Math.round(metric.percentComplete),
      dailyScores: normalizeMetricValues(metric.metricValues, metric.targetValue, metric.metricPeriod),
    }));
  }
}
